import apiService from './apiService'

const bienService = {
  // Récupérer tous les biens avec filtres et pagination
  async getBiens(page = 1, perPage = 10, filters = {}) {
    try {
      // Remove empty filter values to avoid sending empty parameters
      const cleanFilters = {}
      for (const key in filters) {
        if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
          cleanFilters[key] = filters[key]
        }
      }
      
      const queryParams = new URLSearchParams({
        ...cleanFilters,
        page,
        per_page: perPage
      }).toString()
      
      const response = await apiService.get(`/properties?${queryParams}`)
      return response
    } catch (error) {
      console.error('Erreur lors de la récupération des biens:', error)
      throw error
    }
  },

  // Récupérer un bien par ID
  async getBienById(id) {
    try {
      const response = await apiService.get(`/properties/${id}`)
      return response
    } catch (error) {
      console.error('Erreur lors de la récupération du bien:', error)
      throw error
    }
  },

  // Créer un nouveau bien
  async createBien(bienData) {
    try {
      const formData = new FormData()
      
      // Ajouter les champs de base
      Object.keys(bienData).forEach(key => {
        if (key !== 'plan' && key !== 'temoin') {
          formData.append(key, bienData[key])
        }
      })

      // Ajouter les fichiers s'ils existent
      if (bienData.plan) {
        formData.append('plan', bienData.plan)
      }
      if (bienData.temoin) {
        formData.append('temoin', bienData.temoin)
      }

      const response = await apiService.uploadFile('/properties', formData)
      return response
    } catch (error) {
      console.error('Erreur lors de la création du bien:', error)
      throw error
    }
  },

  // Mettre à jour un bien
  async updateBien(id, bienData) {
    try {
      const response = await apiService.put(`/properties/${id}`, bienData)
      return response
    } catch (error) {
      console.error('Erreur lors de la mise à jour du bien:', error)
      throw error
    }
  },

  // Supprimer un bien
  async deleteBien(id) {
    try {
      const response = await apiService.delete(`/properties/${id}`)
      return response
    } catch (error) {
      console.error('Erreur lors de la suppression du bien:', error)
      throw error
    }
  }
}

export default bienService 